import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoIcon',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "49",
    height: "48",
    viewBox: "0 0 49 48",
    fill: __props.fillColor,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M10 20.4C10 18.1598 10 17.0397 10.436 16.184C10.8195 15.4314 11.4314 14.8195 12.184 14.436C13.0397 14 14.1598 14 16.4 14H31.6C33.8402 14 34.9603 14 35.816 14.436C36.5686 14.8195 37.1805 15.4314 37.564 16.184C38 17.0397 38 18.1598 38 20.4V27.6C38 29.8402 38 30.9603 37.564 31.816C37.1805 32.5686 36.5686 33.1805 35.816 33.564C34.9603 34 33.8402 34 31.6 34H16.4C14.1598 34 13.0397 34 12.184 33.564C11.4314 33.1805 10.8195 32.5686 10.436 31.816C10 30.9603 10 29.8402 10 27.6V20.4Z",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("path", {
      d: "M22 21.0275C22 20.56 22 20.3262 22.091 20.1957C22.1703 20.082 22.2917 20.0109 22.4237 20.0007C22.5752 19.9891 22.7584 20.1155 23.1247 20.3683L27.4323 23.3408C27.7502 23.5602 27.9091 23.6699 27.964 23.8094C28.012 23.9312 28.012 24.0688 27.964 24.1906C27.9091 24.3301 27.7502 24.4398 27.4323 24.6592L23.1247 27.6317C22.7584 27.8845 22.5752 28.0109 22.4237 27.9993C22.2917 27.9891 22.1703 27.918 22.091 27.8043C22 27.6738 22 27.44 22 26.9725V21.0275Z",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_3)
  ], 8 /* PROPS */, _hoisted_1))
}
}

})